import '../sections/product';
import sections from '@shopify/theme-sections';
import Drawers from '../modules/drawers';
import RemoveDigits from '../modules/remove-digits';
import Flickity from 'flickity';
import 'sticky-kit/dist/sticky-kit';

$(document).ready(() => {

  //   Products
  //
  //////////////////////////////////////////////////////////////////////
  sections.load('product');


  //   Drawers/accordion
  //
  //////////////////////////////////////////////////////////////////////
  new Drawers({
    $container: $('.js-drawers'),
    triggerSelector: '.bold_option_title',
    contentSelectors: ['.bold_option_element', '.bold_help_text']
  });


  //   Remove digits from text blocks
  //
  //////////////////////////////////////////////////////////////////////
  new RemoveDigits({
    textSelector: '.bold_option_title'
  });


  //  Related Product Carousel
  //
  //////////////////////////////////////////////////////////////////////
  const carousel = document.querySelector('.js-related-products-carousel');

  if (carousel) { 
    new Flickity(carousel, {
      cellAlign: 'left',
      wrapAround: true,
      groupCells: true,
      prevNextButtons: true
    });
  }


  //   Sticky Element
  //
  //////////////////////////////////////////////////////////////////////
  const $stickyEl = $('.js-sticky');

  if ($stickyEl.length != 0) {
    $stickyEl.stick_in_parent({
      offset_top: 60
    });
  }
  
});
